const GROUP_ASSETS = Object.freeze({
  academics: "/marketing/module-icons/academics.webp",
  admin: "/marketing/module-icons/admin.webp",
  fees: "/marketing/module-icons/fees.webp",
  attendance: "/marketing/module-icons/attendance.webp",
  reports: "/marketing/module-icons/reports.webp",
  comms: "/marketing/module-icons/comms.webp",
  aira: "/marketing/module-icons/aira-assistant.webp",
});

// Versioned, deterministic derivatives for the 115 active module routes. Each complete alpha
// subject is centred and fitted to the same 420px envelope on a transparent 512px canvas; the
// source objects remain untouched. See the adjacent public manifest and the normalization script.
export const NORMALIZED_MODULE_3D_ROOT = "/marketing/module-identities-normalized/v1";
const normalizedModuleAsset = (key) => `${NORMALIZED_MODULE_3D_ROOT}/${key}.webp`;

const AI_ASSETS = Object.freeze({
  "aira-assistant": normalizedModuleAsset("aira-assistant"),
  "parent-aira": normalizedModuleAsset("parent-aira"),
  "voice-aira": normalizedModuleAsset("voice-aira"),
  "migration-copilot": normalizedModuleAsset("migration-copilot"),
  "compliance-ai": normalizedModuleAsset("compliance-ai"),
  "report-card-ai": normalizedModuleAsset("report-card-ai"),
  "website-builder-ai": normalizedModuleAsset("website-builder-ai"),
  "talk-to-your-data": normalizedModuleAsset("talk-to-your-data"),
  automations: normalizedModuleAsset("automations"),
});

// The 38 operational icons reviewed after the atlas-fragment audit remain recorded here for audit
// compatibility. Their clean/v1 derivatives are the sources used to build normalized/v1; runtime
// surfaces now share the normalized release below.
export const CLEANED_FEATURE_3D_KEYS = Object.freeze([
  "academic-calendar", "announcements", "attendance-alerts", "attendance-analytics",
  "auto-absence-alert", "birthday-wishes", "branch-management", "certificate-generation",
  "circular-management", "complaint-management", "custom-reports", "daily-attendance-report",
  "digital-gradebook", "emergency-alerts", "enquiry-management", "event-updates",
  "fee-reminder", "fee-reports", "front-office", "holiday-management", "hostel-management",
  "id-card-management", "inventory-management", "late-entry-tracking", "library-management",
  "library-reports", "monthly-attendance-report", "promotion-management", "push-notifications",
  "real-time-charts", "role-and-permission", "staff-attendance", "staff-management",
  "staff-shift-tracking", "student-performance", "transport-management", "user-management",
  "visitor-management",
]);
export const group3dAsset = (group) => GROUP_ASSETS[group] || GROUP_ASSETS.admin;

const assetSlug = (value) => String(value || "")
  .toLowerCase()
  .replace(/&/g, " and ")
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-+|-+$/g, "");

export const feature3dAsset = (nameOrKey) => {
  const key = assetSlug(nameOrKey);
  return normalizedModuleAsset(key);
};

// Every operational catalog row has its own generated object. AI rows retain their separately
// art-directed governed-AI set.
export const module3dAsset = (mod) => {
  if (AI_ASSETS[mod?.key]) return AI_ASSETS[mod.key];
  return feature3dAsset(mod?.key);
};

// A deterministic accent gives every feature its own surrounding color without hard-coding 105
// presentation tokens. The image itself remains the primary, multi-color semantic object.
export const feature3dColor = (name, fallback = "#2563EB") => {
  if (!name) return fallback;
  let hash = 0;
  for (const char of name) hash = ((hash << 5) - hash + char.charCodeAt(0)) | 0;
  return `hsl(${Math.abs(hash) % 360} 68% 40%)`;
};

export const AI_PIPELINE_3D = Object.freeze([
  AI_ASSETS["aira-assistant"],
  AI_ASSETS["compliance-ai"],
  AI_ASSETS["report-card-ai"],
  AI_ASSETS.automations,
]);
